import React from 'react';

import Button from '../Button';

export default function Action({ action, title, buttonLabel, disabled }) {
  const noTitle = !title;

  return (
    <div>
      {!noTitle && (
        <h2 className="text-2xl text-slate-800 dark:text-slate-100 font-bold mb-6 flex justify-between w-full">
          {title}
        </h2>
      )}
      <div
        className={noTitle ? '' : 'grid gap-5 md:grid-cols-3 xl:grid-cols-4'}
      >
        <Button
          type="button"
          isSubmitting={false}
          disabled={disabled}
          onClick={action}
        >
          {buttonLabel}
        </Button>
      </div>
    </div>
  );
}
